module.exports = __webpack_public_path__ + "static/header-layer-1-c5ee39fd75e97d3257e7f0034be3695d.png";